module.exports = __webpack_public_path__ + "img/order4.aedd4846.png";